/* eslint-disable no-warning-comments */
/* eslint-disable react/no-array-index-key */
import React, { lazy, useCallback, useEffect, useState, Suspense } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
// import { Avatar } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import { searchUser } from "../../store/asyncMethods/SearchMethods";
import "./header.css";
import ListIcon from "@mui/icons-material/List";
import { FaHome, FaRegCompass } from "react-icons/fa";
import LogoDark from "./LogoTransparent/Tranparent_dark_logo.png";
import logo from "./img/Logo-design.png";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import VideocamIcon from "@mui/icons-material/Videocam";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
// import UploadBlog from "../uploads/UploadBlog";
// import UploadImage from "../uploads/UploadImage";
// import UploadVideos from "../uploads/UploadVideos";
import { useRef } from "react";
import axios from "axios";
import { path } from "../../path";
import { to_Decrypt } from "../CryptoJS/CryptoJS";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import { format } from "timeago.js";
import AnalyticsIcon from "@mui/icons-material/Analytics";

import { gtag } from "ga-gtag";
import { UpdateThemeAction } from "../../store/asyncMethods/ProfileMethods";
import LogoutModal from "../Modals/LogoutModal";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useContext } from "react";
import { WebSocketContext } from "../../WebSocket";
import ProfilePicture from "../ProfilePicture/ProfilePicture";
import FallbackUI from "../Loading/FallbackUI";
import NotificationCard from "../NotificationPage/NotificationCard";
import SearchPopup from "./SearchPopup"

const UploadBlog = lazy(() => import("../uploads/UploadBlog"));
const UploadImage = lazy(() => import("../uploads/UploadImage"));
const UploadVideos = lazy(() => import("../uploads/UploadVideos"));

function Header({ cookie, setCookie }) {
  const dispatch = useDispatch();
  const profileDropdownRef = useRef(null);

  const { user, token } = useSelector((state) => state.AuthReducer);
  const { notification: noti } = useSelector(
    (state) => state.NotificationReducer
  );
  const { postLoading, loadingType } = useSelector(
    (state) => state.NotificationReducer
  );
  const [text, setText] = useState("");

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const [selectedUserIndex, setSelectedUserIndex] = useState(-1);
  const [redirectModal, setRedirectModal] = useState(false);
  const [searchResultDisplay, setSearchResultDisplay] = useState(false);
  const [sidebarDisplay, setsidebarDisplay] = useState(false);
  const [toggleProfileDropdown, settoggleProfileDropdown] = useState("hidden");
  const [togglePostDropdown, settogglePostDropdown] = useState("hidden");
  const [toggleMsgDropdown, settoggleMsgDropdown] = useState("hidden");
  const [toggleNotificationDropdown, settoggleNotificationDropdown] =
    useState("hidden");
  const [togglePostContent, settogglePostContent] = useState(false);
  const [togglePostImageContent, settogglePostImageContent] = useState(false);
  const [togglePostVideoContent, settogglePostVideoContent] = useState(false);
  const [searchMobile, setsearchMobile] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // const [unseenNotification, setunseenNotification] = useState(false);
  // const [messageUnseen, setMessageUnseen] = useState(false);
  const [friendRequestsCnt, setFriendRequestsCnt] = useState(0);
  const [Conversation] = useState([]);
  const [recentSearchesDisplay, setRecentSearchesDisplay] = useState(false);
  const [searchedUserArray, setSearchedUserArray] = useState([]);
  const searchResultsRef = useRef(null);
  // const searchResultsRefs = useRef(null);
  // const [showResults, setShowResults] = useState(false);
  const location = useLocation();
  const [currentScreen, setCurrentScreen] = useState(
    location.pathname.substring(1)
  );

  const [openNoti, setopenNoti] = useState(false);

  const config = {
    headers: {
      "Access-Control-Allow-Origin": `${path}`,
      Authorization: `Bearer ${token}`,
    },
  };
  const getAllFriendRequests = async () => {
    try {
      const res = await axios.get(`${path}/friendRequests/${user._id}`, config);
      setFriendRequestsCnt(res.data.friendrequests.length);
    } catch (error) {
      console.log("error in friendRequest api", error);
    }
  };
  useEffect(() => {
    if (user?.skills?.length === 0) {
      setRedirectModal(true);
    }
  }, []);

  useEffect(() => {
    setCurrentScreen(location.pathname.substring(1));
  }, [location]);

  const fetchRecentUser = async () => {
    try {
      let response = await axios.get(
        `${path}/fetchrecentSearches/${user._id}`,
        config
      );
      console.log("response");
      // console.log("stas", user);
      if (response.data?.searchedUserId?.length > 0) {
        setSearchedUserArray(response.data?.searchedUserId);
        console.log("statusssss", searchedUserArray);
      }
      // console.log(Array.isArray(response.data));
    } catch (error) {
      //setSearchedUserArray([]);
      console.log("errrrrrrrrrrrrr", error);
    }
  };

  const DeleteRecentUser = async ({ DuserID, clearAll }) => {
    try {
      console.log(DuserID, "clear");
      let response = await axios.post(`${path}/DeleteRecentUser/`, {
        DuserID,
        userId: user?._id,
        clearAll,
      });

      if (response.data?.data) {
        //console.log(response.data.data.length)
        setSearchedUserArray(response.data.data);
      }
    } catch (error) {
      console.log(error.response.data.msg);
    }
  };
  const socket = useContext(WebSocketContext);

  useEffect(() => {
    fetchRecentUser();
    getAllFriendRequests();
  }, []);
  useEffect(() => {
    socket.on("friend received", () => {
      setFriendRequestsCnt((prev) => prev + 1);
    });
    socket.on("pull cancel", () => {
      setFriendRequestsCnt((prev) => prev - 1);
    });

    socket.on("contest-received", (data) => {
      console.log(data, "Mai header hu");
      getNotification();
    });

    socket.on("contest-registered", (data) => {
      console.log(data, "Mai registered hu");
      getNotification();
    });

    socket.on("result-received", (data) => {
      console.log(data, "Mai result declared by new api");
      getNotification();
    });

    socket.on("result-created", (data) => {
      console.log(data, "Mai result declare by new socket");
      getNotification();
    });

    socket.on("submission-start", (data) => {
      console.log(data, "Mai submission start declare by new socket");
      getNotification();
    });

    socket.on("contest-created", () => {
      console.log("new contest");
      getNotification();
    });

    socket.on("submission-end", () => {
      console.log("mai contest submission end before hu");
      getNotification();
    });
  }, []);
  // Refs
  const postWrapperRef = useRef();
  const postButtonRef = useRef();
  const msgWrapperRef = useRef();
  const msgButtonRef = useRef();
  const notificationWrapperRef = useRef();
  const notificationButtonRef = useRef();
  const profileWrapperRef = useRef();
  // const profileButtonRef = useRef();
  const postContentWrapperRef = useRef();
  const postImageWrapperRef = useRef();

  const { userData } = useSelector((state) => state.SearchReducer);

  // Get all chats for chat dropdown
  // const getConversations = async () => {
  //   const config = {
  //     headers: {
  //       "Access-Control-Allow-Origin": `${path}`,
  //       Authorization: `Bearer ${token}`,
  //     },
  //     token,
  //   };
  //   try {
  //     const res = await axios.get(`${path}/chat/` + user._id, config);
  //     setConversation(res.data);
  //   } catch (err) {
  //     console.log(err?.response.data);
  //   }
  // };
  useEffect(() => {
    //getConversations();
  }, [toggleMsgDropdown]);

  //console.log(user.email)

  const { push } = useHistory();

  //user search functionality
  const fetchUser = () => {
    dispatch(searchUser(text));
    setSearchResultDisplay(true);
  };

  const [searchdata, setsearchdata] = useState(userData);

  useEffect(() => {
    const updateSearchUser = () => {
      setsearchdata(userData);
    };
    updateSearchUser();
  }, [userData]);

  useEffect(() => {
    //this is debounce which calls the API after.75 sec's
    var debounce;
    if (text.length >= 1) {
      debounce = setTimeout(() => {
        fetchUser();
      }, 750);
    }
    if (text.length < 1) {
      fetchRecentUser();
      setRecentSearchesDisplay(true);
    }
    if (text.length >= 0) {
      setRecentSearchesDisplay(false);
    }
    return () => {
      clearTimeout(debounce);
    };
  }, [text]);

  //changing colors randomly for name image

  // Mobile Hamburger menu toggle
  const handleHembergerMenu = (e) => {
    e.preventDefault();
    setsidebarDisplay(!sidebarDisplay);
  };

  const pattern = /\bpo[a-zA-Z]{2}[0-9]{13}/i;
  const pattern2 = /\bno[a-zA-Z]{2}[0-9]{13}/i;
  const history = useHistory();

  useEffect(() => {
    if (pattern.test(text) || pattern2.test(text)) {
      history.push(`/posts/${text}`);
    }
  }, [text]);

  //Handle upload post toggle
  const handletogglePostContent = useCallback(() => {
    // document.body.style.overflow = "auto";
    // document.getElementById("home-content").style.opacity = 1;
    settogglePostContent((curr) => !curr);
    settogglePostVideoContent(false);
    settogglePostDropdown("hidden");
    settogglePostImageContent(false);
    //   document.getElementById("home-content").style.opacity = 0.1;
    //   document.body.style.overflow = "hidden";
  }, [togglePostContent]);

  const handletogglePostImageContent = useCallback(() => {
    //   document.body.style.overflow = "auto";
    settogglePostImageContent(!togglePostImageContent);
    settogglePostContent(false);
    settogglePostVideoContent(false);
    settogglePostDropdown("hidden");
    //   document.getElementById("home-content").style.opacity = 0.1;
    //   document.body.style.overflow = "hidden";
  }, [togglePostImageContent]);
  const handletogglePostVideoContent = useCallback(() => {
    // if (user.skills.length === 0) {
    // }
    settogglePostContent(false);
    settogglePostVideoContent(!togglePostVideoContent);
    settogglePostImageContent(false);
    settogglePostDropdown("hidden");
    //   document.getElementById("home-content").style.opacity = 0.1;
    //   document.body.style.overflow = "hidden";
  }, [togglePostVideoContent]);

  const handleInputClick = (event) => {
    // Prevent the click event from propagating to the document click handler
    event.stopPropagation();
  };

  // Handle Profile Dropdown
  // const handleProfileDropdown = useCallback(
  //   (e) => {
  //     if(user?.skills.length==0){return;}
  //     e.preventDefault();
  //     if (toggleProfileDropdown == "hidden") {
  //       settoggleProfileDropdown("flex");
  //       settoggleNotificationDropdown("hidden");
  //       settogglePostDropdown("hidden");
  //       settoggleMsgDropdown("hidden");
  //       //   document.getElementById("home-content").style.opacity = 0.1;
  //     } else {
  //       settoggleProfileDropdown("hidden");
  //       //   document.getElementById("home-content").style.opacity = 1;
  //     }
  //   },
  //   [toggleProfileDropdown]
  // );

  const handleProfileDropdown = useCallback(
    (e) => {
      e.preventDefault();
      if (
        toggleProfileDropdown === "hidden" ||
        location.pathname === "/timeline"
      ) {
        settoggleProfileDropdown("flex");
        settoggleNotificationDropdown("hidden");
        settogglePostDropdown("hidden");
        settoggleMsgDropdown("hidden");
      } else {
        settoggleProfileDropdown("hidden");
      }
    },
    [toggleProfileDropdown, location.pathname, user]
  );

  // Add event listener to collapse dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileWrapperRef.current &&
        !profileWrapperRef.current.contains(event.target)
      ) {
        settoggleProfileDropdown("hidden");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileWrapperRef]);

  // Handle Post Dropdown
  const handlePostDropdown = () => {
    if (user.skills.length === 0) {
      console.log(redirectModal, "India hargaya");
      history.push("/home");
      return;
    }

    history.push("/competition");
    // e.preventDefault();
    // console.log(" handlePostDropdown clicked");
    // if (togglePostDropdown === "hidden") {
    //   settogglePostDropdown("flex");
    //   settoggleNotificationDropdown("hidden");
    //   settoggleProfileDropdown("hidden");
    //   settoggleMsgDropdown("hidden");
    //   //   document.getElementById("home-content").style.opacity = 0.1;
    //   //   document.body.style.overflow = "auto";
    // } else {
    //   //   document.getElementById("home-content").style.opacity = 1;
    //   settogglePostDropdown("hidden");
    //   //   document.body.style.overflow = "auto";
    // }
    // settogglePostContent(false);
    // settogglePostImageContent(false);
    // settogglePostVideoContent(false);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (selectedUserIndex >= 0 && selectedUserIndex < text.length) {
        // setShowResults(false);
      }
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setSelectedUserIndex(Math.max(selectedUserIndex - 1, -1));
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
    }
  };

  //Handle Msg Dropdown
  const handleDocumentClick = (event) => {
    if (
      searchResultsRef.current &&
      !searchResultsRef.current.contains(event.target)
    ) {
      // setShowResults(false);
      // const elements = document.getElementsByClassName('srch');
      // for (let i = 0; i < elements.length; i++) {
      //   elements[i].style.display = 'none';
      // }
    }
    setText("");
    setRecentSearchesDisplay(false);
    //console.log("Boxes desire");
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleMsgDropdown = (e) => {
    console.log(user);
    e.preventDefault();
    if (toggleMsgDropdown === "hidden") {
      settoggleMsgDropdown("flex");
      settoggleNotificationDropdown("hidden");
      settoggleProfileDropdown("hidden");
      settogglePostDropdown("hidden");
      //   document.getElementById("home-content").style.opacity = 0.1;
    } else {
      settoggleMsgDropdown("hidden");
      //   document.getElementById("home-content").style.opacity = 1;
    }
  };

  const [isDark, setIsDark] = useState(user.theme === "dark" ? true : false);

  const handleTheme = () => {
    const root = window.document.documentElement;
    if (user.theme === "dark") {
      root.classList.remove("dark");
      root.classList.add("light");
      dispatch(UpdateThemeAction("light"));
      setIsDark(false);
      // setTheme("light");
      setCookie("Theme", "light", { path: "/" });
      setCookie({ ...cookie, Theme: "light" }); // Update the Theme property
    } else {
      root.classList.remove("light");
      root.classList.add("dark");
      dispatch(UpdateThemeAction("dark"));
      setIsDark(true);
      // setTheme("dark");
      setCookie("Theme", "dark", { path: "/" });
      setCookie({ ...cookie, Theme: "dark" }); // Update the Theme property
    }
    console.log("user.theme:", user.theme);
    console.log(cookie.Theme); // Should now log the updated value
  };

  const getNotification = async () => {
    try {
      const response = await axios.get(
        `${path}/getNotification/${user._id}`,
        config
      );
      const filteredNoti = response.data.data.filter(
        (noti) =>
          noti.fromUserId !== null &&
          noti.type !== "Not Improve" &&
          noti.type !== "Unappreciate" &&
          noti.postId !== null
      );
      dispatch({ type: "UPDATE_NOTIFICATION", payload: filteredNoti });
    } catch (error) {
      console.log(error);
    }
  };

  function logoutSocketEvent() {
    socket.emit("disconnectt", user._id);
  }

  useEffect(() => {
    const updateUser = async () => {
      try {
        const config = {
          headers: {
            "Access-Control-Allow-Origin": `${path}`,
            Authorization: `Bearer ${token}`,
          },
        };
        const res = await axios.get(`${path}/getUserData/${user._id}`, config);
        dispatch({ type: "UPDATE_ACCOUNT", payload: res.data });
      } catch (error) {
        console.log("Error: ", error);
      }
    };
    updateUser();
  }, []);

  useEffect(() => {
    // getNotification();
    // if (window.location.hash !== "#/allNotifications") {
    socket.on("notification received", () => {
      // console.log("header page");
      dispatch({ type: "SET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(true);
    });
    socket.on("connected", () => {
      // setSocketConnected(true);
      console.log("Socket connected");
    });
    socket.on("profile update", () => {
      dispatch({ type: "SET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(true);
    });

    socket.on("friend received", () => {
      dispatch({ type: "SET_NOTIFICATION" });
      // console.log("header page");
      // getNotification();
      // setunseenNotification(true);
    });

    socket.on("post notification recieved", () => {
      dispatch({ type: "SET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(true);
    });

    socket.on("name update", () => {
      dispatch({ type: "SET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(true);
    });

    // Notification code for contest
    // socket.on("contest-registered", (payload) => {
    //   dispatch({ type: "SET_NOTIFICATION" });
    //   // getNotification();
    //   setunseenNotification(true);
    // });

    socket.on("pull cancel", () => {
      dispatch({ type: "UNSET_NOTIFICATION" });
      // setunseenNotification(false);
    });

    // Added but not tested yet
    socket.on("accept request", () => {
      dispatch({ type: "UNSET_NOTIFICATION" });
      // getNotification();
      // setunseenNotification(false);
    });

    // socket.on("accept request", (data) => {
    //   dispatch({ type: "SET_NOTIFICATION" });
    //   const filteredFriends = user.friends.filter((id) => id != data);
    //   dispatch({
    //     type: UPDATE_ACCOUNT,
    //     payload: {
    //       ...user,
    //       friends: [...filteredFriends, data],
    //     },
    //   });
    // });

    socket.on("removed friend", () => {
      // let updatedUser = {
      //   ...user,
      //   friends: user.friends.filter((friend) => friend != remover),
      // };
      // dispatch({ type: UPDATE_ACCOUNT, payload: updatedUser });
    });
    // }

    socket.on("uni-message-socket-recieved", (data) => {
      console.log(window.localStorage.hash);

      if (
        data.type === "message-recieved" &&
        window.location.hash !== "#/chatting"
      ) {
        dispatch({ type: "SET_MSG_NOTIFICATION" });
        // setMessageUnseen(true);
      }
    });
  }, []);

  useEffect(() => {
    const postevent = (event) => {
      const classList = event.target.classList;
      if (classList.contains("post-event")) {
        gtag("event", "post", {});
      } else if (classList.contains("message-event")) {
        gtag("event", "message", {});
      } else if (classList.contains("notification-event")) {
        gtag("event", "notification", {});
      } else if (classList.contains("profile-event")) {
        gtag("event", "profile", {});
      } else if (classList.contains("search-tab-event")) {
        gtag("event", "search-tab", {});
      }
    };

    document.addEventListener("click", postevent);

    return () => {
      document.removeEventListener("click", postevent);
    };
  }, []);

  // ${!recentSearchesDisplay&&"hidden"
  // const [theme, setTheme] = useState(user.theme === "dark" ? "dark" : "light");

  return (
    <>
      {postLoading && (
        <div
          className={`fixed top-[85vh] right-[10vw] md:right-[1vw] h-[10vh] w-[80vw] md:w-[28vw] rounded-lg ${user.theme === "dark" ? "bg-secondary" : "bg-primary"
            } shadow-2xl text-primary justify-center flex items-center gap-2 p-3`}
          style={{ zIndex: 31 }}>
          <div
            className={`flex w-[95%] ${user.theme === "dark" ? "bg-primary" : "bg-secondary"
              } rounded-xl min-h-[60%] h-fit gap-3 p-2`}>
            <div className="spinner"></div>
            <div className="font-semibold"> {loadingType} </div>
          </div>
        </div>
      )}
      <div className={`fixed top-0 z-30`}>
        <LogoutModal
          showLogoutModal={showLogoutModal}
          setShowLogoutModal={setShowLogoutModal}
          logoutSocketEvent={logoutSocketEvent}
        />
        <div
          className={` ${!recentSearchesDisplay && "hidden"
            } fixed top-0 left-0 w-[100%] h-[100%] bg-black text-primary opacity-50 -z-10`}></div>
        <div
          className="flex sm:hidden flex-row justify-between items-center w-[100vw] px-3 pr-2 bg-primary"
          style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}>
          {!searchMobile && (
            <div className="flex flex-row items-center justify-between ">
              <button onClick={handleHembergerMenu}>
                <ListIcon
                  fontSize="large"
                  className="text-3xl text-slate-400"
                />
              </button>
              <Link
                to="/home"
                onClick={() => dispatch({ type: "UNSET_SHARE_POST_ID" })}>
                <img
                  src={user.theme === "light" ? logo : LogoDark}
                  className="ml-2 h-4"
                  alt="FeedAnts"
                />
              </Link>
            </div>
          )}

          <div className="flex flex-row mr-1">
            <Link
              to="/allNotifications"
              onClick={() => setsidebarDisplay(false)}
              className={searchMobile ? "hidden" : ""}>
              <li className="flex m-[2%] my-[3%] items-center">
                {/* <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-[10%]  message-event"
                  onClick={() => {
                    // setMessageUnseen(false);
                    dispatch({ type: "UNSET_MSG_NOTIFICATION" });
                  }}>
                  <circle
                    cx="24"
                    cy="24"
                    r="24"
                    fill={user.theme === "dark" ? "#212b36" : "#F6F5FA"}
                  />

                  <g clipPath="url(#clip0_807_3064)">
                    <path
                      d="M24.006 31.7767C23.6887 31.7767 23.3687 31.6647 23.114 31.438L20.6153 29.3333H18.6667C17.196 29.3333 16 28.1373 16 26.6667V18.6667C16 17.196 17.196 16 18.6667 16H29.3333C30.804 16 32 17.196 32 18.6667V26.6667C32 28.1373 30.804 29.3333 29.3333 29.3333H27.432L24.8673 31.4533C24.6267 31.668 24.3173 31.7767 24.006 31.7767Z"
                      fill="#637381"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_807_3064">
                      <rect
                        width="26"
                        height="26"
                        fill="white"
                        transform="translate(16 16)"
                      />
                    </clipPath>
                  </defs>
                </svg> */}

                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-[10%]  message-event"
                  onClick={() => {
                    // setMessageUnseen(false);
                    dispatch({ type: "UNSET_MSG_NOTIFICATION" });
                  }}>
                  <circle
                    cx="24"
                    cy="24"
                    r="24"
                    // fill="#F6F5FA"
                    fill={user.theme === "dark" ? "#212b36" : "#F6F5FA"}
                  />
                  <g clipPath="url(#clip0_807_3068)">
                    <path
                      d="M18.7119 28H29.1492C29.4704 28 29.7869 27.9226 30.0719 27.7745C30.3569 27.6263 30.602 27.4116 30.7865 27.1486C30.971 26.8857 31.0894 26.5822 31.1318 26.2637C31.1742 25.9453 31.1392 25.6214 31.0299 25.3193L29.1285 20.0627C28.8038 18.8945 28.1054 17.8648 27.1401 17.1311C26.1748 16.3974 24.9957 16.0001 23.7832 16C22.521 16 21.2966 16.4304 20.312 17.2202C19.3275 18.01 18.6417 19.1119 18.3679 20.344L16.8012 25.4107C16.709 25.7098 16.6882 26.0264 16.7407 26.335C16.7931 26.6436 16.9172 26.9356 17.1031 27.1875C17.289 27.4394 17.5314 27.6441 17.8108 27.7852C18.0902 27.9264 18.3988 27.9999 18.7119 28Z"
                      fill="#637381"
                    />
                    <path
                      d="M20.7334 29.3335C20.8864 30.087 21.2952 30.7645 21.8906 31.2511C22.4859 31.7377 23.2312 32.0035 24.0001 32.0035C24.769 32.0035 25.5142 31.7377 26.1096 31.2511C26.7049 30.7645 27.1137 30.087 27.2667 29.3335H20.7334Z"
                      fill="#637381"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_807_3068">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(16 16)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </li>
            </Link>
            <Link
              to="/chatting"
              className={`message-event ${searchMobile ? "hidden" : ""} group relative bottom-zero flex items-center mx-[3%] lg:mx-[4%]`}>
              <button
                ref={msgButtonRef}
                className="message-event flex items-center mx-[3%] lg:mx-[4%]"
              // onClick={handleMsgDropdown}
              >
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-[10%]  message-event"
                  onClick={() => {
                    // setMessageUnseen(false);
                    dispatch({ type: "UNSET_MSG_NOTIFICATION" });
                  }}>
                  <circle
                    cx="24"
                    cy="24"
                    r="24"
                    fill={user.theme === "dark" ? "#212b36" : "#F6F5FA"}
                  />
                  {/* <circle

                  fill="#F6F5FA"
                    cx="25"
                    cy="6"
                    r="4"
                    fill={
                      messageUnseen === true || msgNotification === true
                        ? "rgba(0, 128, 128, 1)"
                        : "#475569"
                    }
                  /> */}
                  <g clipPath="url(#clip0_807_3064)">
                    <path
                      d="M24.006 31.7767C23.6887 31.7767 23.3687 31.6647 23.114 31.438L20.6153 29.3333H18.6667C17.196 29.3333 16 28.1373 16 26.6667V18.6667C16 17.196 17.196 16 18.6667 16H29.3333C30.804 16 32 17.196 32 18.6667V26.6667C32 28.1373 30.804 29.3333 29.3333 29.3333H27.432L24.8673 31.4533C24.6267 31.668 24.3173 31.7767 24.006 31.7767Z"
                      fill="#637381"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_807_3064">
                      <rect
                        width="26"
                        height="26"
                        fill="white"
                        transform="translate(16 16)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <div className="py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity bg-black rounded-full top-10  absolute ">
                <h3 className="text-white font-semibold text-xs">Chats</h3>
              </div>
            </Link>
            <div
              className="cursor-pointer flex justify-center items-center"
              onClick={() => {
                setsearchMobile(!searchMobile);
                setRecentSearchesDisplay((prev) => {
                  return !prev;
                });
              }}>
              {!searchMobile ? (
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mt-[3.5]">
                  <g clipPath="url(#clip0_807_3040)">
                    <path
                      d="M11.7805 10.7226L9.45793 8.39905C11.1958 6.07667 10.7219 2.78517 8.39954 1.04731C6.07716 -0.690552 2.78566 -0.216694 1.0478 2.10569C-0.690063 4.42808 -0.216206 7.71958 2.10618 9.45744C3.97171 10.8534 6.53399 10.8534 8.39954 9.45744L10.7231 11.781C11.0151 12.073 11.4885 12.073 11.7805 11.781C12.0725 11.489 12.0725 11.0156 11.7805 10.7236L11.7805 10.7226ZM5.27223 9.00897C3.2082 9.00897 1.53499 7.33576 1.53499 5.27174C1.53499 3.20771 3.2082 1.5345 5.27223 1.5345C7.33625 1.5345 9.00946 3.20771 9.00946 5.27174C9.00726 7.33483 7.33534 9.00678 5.27223 9.00897Z"
                      fill="#637381"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_807_3040">
                      <rect width="12" height="12" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              ) : (
                <CancelIcon
                  onClick={() => setText("")}
                  fontSize="small"
                  className="text-4xl mt-2 text-slate-400 pos cursor-pointer"
                />
              )}
            </div>
          </div>
        </div>

        {/* Mob sidebar */}
        <div className="border border-viewMore">
          <ul
            className={` shadow-xl rounded-b-md sm:hidden absolute transition-all ${sidebarDisplay ? "left-0" : "-left-full"
              } bg-card w-[100vw] h-fit text-primary`}>
            <Link
              to={`/mystatistics/${user._id}`}
              onClick={() => setsidebarDisplay(false)}>
              <li className=" flex mx-[2%] my-[3%] items-center">
                {/* <AccountCircleOutlinedIcon className="text-[#637381]  dark:text-primary mx-[10%]  mt-[2%]" />{" "} */}

                <span className="mx-[3%] mr-[5%]  mt-[2%]">
                  <AnalyticsIcon className="text-[#637381]" />
                </span>
                <span className="text-[#637381] mt-[2%]  dark:text-primary">
                  {" "}
                  My Statistics
                </span>
              </li>
            </Link>
            <Link to="/peerInterests" onClick={() => setsidebarDisplay(false)}>
              <li className="flex m-[2%] my-[3%] items-center">
                <GroupAddOutlinedIcon className="text-slate-500 mx-[3%] mr-[5%] mt-[2%]" />{" "}
                <span className="mt-[2%] text-[#637381] dark:text-primary">
                  Peer Interests
                  {friendRequestsCnt >= 0 && (
                    <span> ({friendRequestsCnt})</span>
                  )}
                </span>
              </li>
            </Link>

            {/* <hr className="border-viewMore"></hr> */}
            <Link to="/wirings" onClick={() => setsidebarDisplay(false)}>
              <li className="flex m-[2%] my-[3%] items-center">
                <GroupAddOutlinedIcon className="text-slate-500 mx-[3%] mr-[5%] mt-[2%]" />{" "}
                <span className="mt-[2%] text-[#637381] dark:text-primary">
                  Wirings
                </span>
              </li>
            </Link>
            {/* <hr className="border-viewMore"></hr> */}

            {/* <hr className="border-viewMore" /> */}
            <Link
              to={`/accountInfo/${user._id}`}
              onClick={() => setsidebarDisplay(false)}>
              <li className={`flex items-center m-[2%] my-[3%] ml-[2.5%]`}>
                {" "}
                <SettingsApplicationsIcon
                  fontSize="medium"
                  className="text-slate-500 mx-[1.5%] mr-[5%] mt-[2%] "
                />
                <span className="mt-[2%] text-[#637381] ml-[1px] w-0 dark:text-primary">
                  Settings{" "}
                </span>{" "}
              </li>
            </Link>
            {/* <hr className="border-viewMore" /> */}

            {/* <hr className="border-viewMore" /> */}
            <a onClick={() => setShowLogoutModal(true)}>
              <li className="flex m-[2%] my-[3%] items-center cursor-pointer">
                <LogoutOutlinedIcon
                  fontSize="medium"
                  className="text-slate-500 mx-[2%] mr-[5%] mt-[2%]"
                />{" "}
                <span className="mt-[2%] text-[#637381] dark:text-primary ml-[3px]">
                  Logout{" "}
                </span>{" "}
              </li>
            </a>
            <hr className="border-viewMore" />
            <div className="flex flex-row pt-4 ">
              <div className="w-full flex flex-row justify-center">
                Appearance
              </div>
            </div>
            <div className="flex flex-row justify-center  pt-2 pb-5">
              <button
                onClick={handleTheme}
                disabled={!isDark}
                className={`${!isDark ? "bg-teal-600" : "bg-inherit"} mx-4 flex flex-row px-3 justify-center text-white py-3 rounded-sm`}>
                {" "}
                <LightModeIcon
                  className="text-white   mt-[2%]"
                  sx={{ color: "#b3b3b3" }}
                />
                <span className="text-white  mx-2 ">Light</span>
              </button>
              <button
                onClick={handleTheme}
                disabled={isDark}
                className={`flex flex-row  ${isDark ? "bg-teal-600" : "bg-compBgSec"} px-3 justify-center py-3`}>
                {" "}
                <DarkModeIcon
                  className="text-black  mt-[2%]"
                  sx={{ color: "#b3b3b3" }}
                />
                <span className="text-black mx-2">Dark</span>
              </button>
            </div>
          </ul>
        </div>
        {sidebarDisplay && (
          <div
            className="fixed w-[100vw] h-[100vh] bg-[black] opacity-30 -z-10"
            onClick={() => setsidebarDisplay(false)}></div>
        )}

        {
          //Web Navbar
        }
        <div className=" hidden sm:flex gap-12 flex-row  items-center justify-center shadow-lg p-1 w-[100vw] bg-card">
          <div className="flex flex-row items-center gap-3 [@media(max-width:974px)]:gap-2 [@media(max-width:974px)]:mr-4 [@media(max-width:769px)]:relative [@media(max-width:769px)]:right-[1.5%]">
            <Link
              to="/home"
              onClick={() => {
                dispatch({ type: "UNSET_SHARE_POST_ID" });
                settoggleProfileDropdown("hidden");
              }}>
              <img
                src={user.theme === "light" ? logo : LogoDark}
                className="ml-0 h-7 mr-10"
                alt="FeedAnts"
              />
            </Link>
            <div className="flex justify-center w-[40vw] items-center ml-10 mt-1 [@media(max-width:974px)]:w-[25vw] [@media(max-width:974px)]:ml-1">

              <div className=" absolute top-[22%] w-[25%] left-[26.5%] tb:top-[-9%] tb:left-[39%] tb:w-[60%]">
                <input
                  type="text"
                  maxLength={30}
                  onChange={(e) => setText(e.target.value)}
                  value={text}
                  className={`text-grayish search-tab-event p-4 rounded-2xl border border-viewMore w-full h-8 bg-primary outline-none dark:text-primary Searchbox ${(searchResultDisplay && text.length > 0) ? "border-b-primary rounded-b-none" : ""}`}
                  onClick={(e) => {

                    setRecentSearchesDisplay(true);
                    // setShowResults(user?.skills.length !== 0);
                    handleInputClick(e);
                  }}
                  onKeyDown={handleKeyDown}
                  placeholder="Search Peers and more"
                />

                <div
                  style={{
                    alignItems: "center",
                    marginTop: "0.5rem",
                  }} className={` relative inline-block ${text.length > 0 ? " left-[87%] bottom-[2.2rem] llp:left-[91%] lap:left-[89%] 4k:left-[92%]" : " bottom-[1.9rem] left-[92%]"}`}>
                  {text.length === 0 ? (
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mb-2 text-viewMore">
                      <g clipPath="url(#clip0_807_3040)">
                        <path
                          d="M11.7805 10.7226L9.45793 8.39905C11.1958 6.07667 10.7219 2.78517 8.39954 1.04731C6.07716 -0.690552 2.78566 -0.216694 1.0478 2.10569C-0.690063 4.42808 -0.216206 7.71958 2.10618 9.45744C3.97171 10.8534 6.53399 10.8534 8.39954 9.45744L10.7231 11.781C11.0151 12.073 11.4885 12.073 11.7805 11.781C12.0725 11.489 12.0725 11.0156 11.7805 10.7236L11.7805 10.7226ZM5.27223 9.00897C3.2082 9.00897 1.53499 7.33576 1.53499 5.27174C1.53499 3.20771 3.2082 1.5345 5.27223 1.5345C7.33625 1.5345 9.00946 3.20771 9.00946 5.27174C9.00726 7.33483 7.33534 9.00678 5.27223 9.00897Z"
                          fill="#637381"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_807_3040">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  ) : (
                    <CancelIcon
                      onClick={() => setText("")}
                      className="mr-1 mb-1 text-viewMore"
                    />
                  )}
                </div>

                <button
                  ref={postButtonRef}
                  className="post-event relative left-[103%] bottom-[4.2rem] p-1 transition duration-200 flex items-center justify-evenly rounded-3xl bg-[#F6F5FA] hover:bg-hover px-2 border border-viewMore"
                  onClick={() => {
                    handlePostDropdown();
                  }}


                >
                  <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" className="[@media(max-width:974px)]:w-[24px] [@media(max-width:974px)]:h-[24px]">
                    <g clipPath="url(#clip0_3892_2624)">
                      <path d="M8.23728 10.8394H8.73699C12.3849 10.8394 13.6792 8.65194 13.6792 6.77694C13.6787 6.26881 13.5227 5.77674 13.2381 5.38521C12.9536 4.99369 12.5581 4.72714 12.1197 4.63132C12.2075 4.42934 12.2826 4.22048 12.3442 4.00632C12.4401 3.64066 12.4589 3.25444 12.3992 2.87895C12.3395 2.50346 12.2029 2.14927 12.0005 1.84507C11.7963 1.53159 11.5301 1.27722 11.2235 1.10252C10.9169 0.927817 10.5785 0.837696 10.2356 0.839441H3.94361C3.6006 0.837913 3.26208 0.928323 2.95547 1.10335C2.64885 1.27838 2.38275 1.53312 2.1787 1.84694C1.97629 2.15115 1.8397 2.50534 1.77997 2.88083C1.72025 3.25631 1.73908 3.64253 1.83494 4.00819C1.89662 4.22235 1.97168 4.43122 2.05954 4.63319C1.62137 4.72895 1.22613 4.99523 0.941583 5.38637C0.657037 5.7775 0.500919 6.26913 0.5 6.77694C0.5 8.65194 1.79431 10.8394 5.4422 10.8394H5.94191C5.9739 11.0292 5.99044 11.2219 5.99133 11.4151V13.3394C6.00076 13.5064 5.97882 13.6737 5.92697 13.8302C5.87511 13.9867 5.79453 14.1289 5.69061 14.2472C5.58668 14.3655 5.46179 14.4572 5.32426 14.5162C5.18674 14.5752 5.03974 14.6002 4.89306 14.5894H3.7948C3.64916 14.5894 3.50948 14.6553 3.4065 14.7725C3.30352 14.8897 3.24566 15.0487 3.24566 15.2144C3.24566 15.3802 3.30352 15.5392 3.4065 15.6564C3.50948 15.7736 3.64916 15.8394 3.7948 15.8394H10.3844C10.53 15.8394 10.6697 15.7736 10.7727 15.6564C10.8757 15.5392 10.9335 15.3802 10.9335 15.2144C10.9335 15.0487 10.8757 14.8897 10.7727 14.7725C10.6697 14.6553 10.53 14.5894 10.3844 14.5894H9.28942C9.14252 14.6005 8.99524 14.5758 8.8574 14.517C8.71955 14.4581 8.59432 14.3665 8.49007 14.2482C8.38581 14.1299 8.30493 13.9876 8.25281 13.8309C8.2007 13.6742 8.17856 13.5067 8.18786 13.3394V11.4144C8.18878 11.2215 8.20532 11.029 8.23728 10.8394ZM9.13566 9.05757C10.0766 8.10886 10.8906 7.00868 11.5518 5.79194C11.617 5.82263 11.6867 5.83876 11.7572 5.83944C11.9757 5.83944 12.1852 5.93821 12.3397 6.11403C12.4941 6.28984 12.5809 6.5283 12.5809 6.77694C12.5809 8.13694 11.5711 9.58944 8.73699 9.58944H8.70624C8.83006 9.39313 8.97424 9.21455 9.13566 9.05757ZM5.4422 9.58944C2.60812 9.58944 1.59827 8.13694 1.59827 6.77694C1.59827 6.5283 1.68505 6.28984 1.83952 6.11403C1.994 5.93821 2.20351 5.83944 2.42197 5.83944C2.49265 5.83884 2.56257 5.82271 2.62789 5.79194C3.28915 7.00868 4.10316 8.10886 5.04408 9.05757C5.2053 9.21459 5.3493 9.39317 5.47295 9.58944H5.4422Z" fill="#637381" />
                    </g>
                    <defs>
                      <clipPath id="clip0_3892_2624">
                        <rect width="13.1792" height="15" fill="white" transform="translate(0.5 0.839417)" />
                      </clipPath>
                    </defs>
                  </svg>

                  <h2 className="post-event ml-2 mr-[1%] text-primary [@media(max-width:974px)]:hidden">Competition</h2>
                </button>

                <SearchPopup searchResultDisplay={searchResultDisplay} text={text} setSearchResultDisplay={setSearchResultDisplay} searchdata={searchdata} setText={setText} />

                {
                  //recent searches
                  recentSearchesDisplay && searchedUserArray?.length !== 0 && (
                    <>
                      <div className="flex-column relative w-full bottom-[4.25rem] bg-card border rounded-2xl border-primary overflow-hidden shadow-xl ">
                        <div
                          className={
                            "flex flex-row justify-between w-[100%] " +
                            (searchMobile ? " top-9 " : " top-14 ")
                          }>
                          <div className="p-2 text-primary">
                            <p>Recent Searches</p>
                          </div>
                          <div
                            className="p-2  "
                            onClick={() => {
                              DeleteRecentUser({ DuserID: user?._id, clearAll: true });
                            }}>
                            <p className="cursor-pointer text-[0.75rem] text-gray-500 pt-1">
                              Clear All
                            </p>
                          </div>
                        </div>
                        <hr className="border-viewMore" />
                        {searchedUserArray?.length > 0 ? (
                          <ul
                            className="flex-col overflow-x-hidden w-full bg-card srch max-h-[40vh] overflow-y-scroll"
                            ref={searchResultsRef}>
                            {searchedUserArray?.map((u, index) => {
                              return (
                                <div
                                  key={index}
                                  className="flex hover:bg-primary cursor-pointer ">
                                  <Link
                                    to={`/userDetails/${u?._id}`}
                                    key={u._id}
                                    onClick={() => {
                                      //dispatch({ type: "LOGOUT_SR" });
                                    }}
                                    className="flex px-2 py-1 space-x-1 w-[60%]">
                                    <div
                                      className={`${selectedUserIndex === index ? "selected" : ""
                                        }`}>
                                      <ProfilePicture profilePic={u} />
                                    </div>
                                    <div
                                      className={`flex flex-col ${searchMobile ? `max-w-[55%]` : `w-full`
                                        } `}>
                                      <li className="text-[#637381] font-semibold whitespace-nowrap overflow-hidden  text-ellipsis">
                                        {" "}
                                        {u.firstName} {u.lastName}
                                      </li>
                                      <p className="text-[0.5rem] text-[#637381]">
                                        {u.username}
                                      </p>
                                    </div>
                                  </Link>
                                  <div
                                    className="z-50 ml-[31%] cursor-pointer py-3"
                                    onClick={() => {
                                      let DuserID = u._id;
                                      let clearAll = false;
                                      DeleteRecentUser({ DuserID, clearAll });
                                    }}>
                                    <CancelIcon
                                      fontSize="small"
                                      className="text-4xl text-red-500 "
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </ul>
                        ) : (
                          <h2 className="p-2 pl-4 text-[#637381] font-semibold">
                            No Recently Searched User Found!!
                          </h2>
                        )}
                      </div>
                    </>
                  )
                }
              </div>

              {/* <button
                className="flex items-center mt-1"
                data-testid="Searchid"
                onClick={() => fetchUser()}>
                {text.length == 0 ? (
                  <SearchIcon className="mb-2 -ml-9 text-viewMore" />
                ) : (
                  <CancelIcon
                    onClick={() => setText("")}
                    className="mb-2 -ml-9 text-viewMore"></CancelIcon>
                )}
              </button> */}

            </div>
          </div>
          <div className=" flex [@media(max-width:769px)]:relative [@media(max-width:769px)]:right-[2%]">
            <div className="text-viewMore flex items-center rounded-full border border-viewMore px-4 space-x-6">
              <div
                className="relative group bottom-zero flex-1 cursor-pointer"
                onClick={() => {
                  setCurrentScreen("home");
                  push("/home");
                }}>
                <div className="py-1 px-2  opacity-0 group-hover:opacity-100 transition-opacity bg-black rounded-full top-7 -left-2 absolute ">
                  <h3 className="text-white font-semibold text-xs">Home</h3>
                </div>
                <FaHome
                  size={25}
                  // title="Home"
                  color={currentScreen === "home" ? "#329999" : "inherit"}
                />
              </div>
              <div
                className="relative group bottom-zero flex-1 cursor-pointer"
                onClick={() => {
                  setCurrentScreen("timeline");
                  push("/timeline");
                }}>
                <div className="py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity bg-black rounded-full top-7 -left-4 absolute ">
                  <h3 className="text-white font-semibold text-xs">Timeline</h3>
                </div>
                <FaRegCompass
                  size={25}
                  // title="Timeline"
                  color={currentScreen === "timeline" ? "#329999" : "inherit"}
                />
              </div>
            </div>
            <Link
              to="/chatting"
              className="message-event group relative bottom-zero flex items-center mx-[3%] lg:mx-[4%]">
              <button
                ref={msgButtonRef}
                className="message-event flex items-center mx-[3%] lg:mx-[4%]"
              // onClick={handleMsgDropdown}
              >
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mr-[10%]  message-event"
                  onClick={() => {
                    // setMessageUnseen(false);
                    dispatch({ type: "UNSET_MSG_NOTIFICATION" });
                  }}>
                  <circle
                    cx="24"
                    cy="24"
                    r="24"
                    fill={user.theme === "dark" ? "#212b36" : "#F6F5FA"}
                  />

                  <g clipPath="url(#clip0_807_3064)">
                    <path
                      d="M24.006 31.7767C23.6887 31.7767 23.3687 31.6647 23.114 31.438L20.6153 29.3333H18.6667C17.196 29.3333 16 28.1373 16 26.6667V18.6667C16 17.196 17.196 16 18.6667 16H29.3333C30.804 16 32 17.196 32 18.6667V26.6667C32 28.1373 30.804 29.3333 29.3333 29.3333H27.432L24.8673 31.4533C24.6267 31.668 24.3173 31.7767 24.006 31.7767Z"
                      fill="#637381"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_807_3064">
                      <rect
                        width="26"
                        height="26"
                        fill="white"
                        transform="translate(16 16)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <div className="py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity bg-black rounded-full top-10  absolute ">
                <h3 className="text-white font-semibold text-xs">Chats</h3>
              </div>
            </Link>
            <button
              ref={notificationButtonRef}
              className="notification-event relative group bottom-zero flex items-center mx-[3%] lg:mx-[0]"
              title="notification"
              onClick={(e) => {
                // setunseenNotification(false);
                dispatch({ type: "UNSET_NOTIFICATION" });
                setopenNoti(true);
                // getNotification();
                handleProfileDropdown(e);
              }}>
              {/* <svg
                width="40"
                height="42"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-[10%] notification-event"
                onClick={() => push(`/allNotifications`)}>
                <path
                  d="M11 29C12.7345 29 14.1414 27.4892 14.1414 25.625H7.85863C7.85863 27.4892 9.26554 29 11 29ZM21.5772 21.1051C20.6284 20.0104 18.8532 18.3635 18.8532 12.9688C18.8532 8.87129 16.1778 5.59121 12.5704 4.78648V3.6875C12.5704 2.75568 11.8672 2 11 2C10.1328 2 9.42956 2.75568 9.42956 3.6875V4.78648C5.82216 5.59121 3.14681 8.87129 3.14681 12.9688C3.14681 18.3635 1.37159 20.0104 0.422845 21.1051C0.128203 21.4453 -0.0024214 21.8519 3.3952e-05 22.25C0.00543572 23.1148 0.637443 23.9375 1.57637 23.9375H20.4236C21.3626 23.9375 21.9951 23.1148 22 22.25C22.0024 21.8519 21.8718 21.4447 21.5772 21.1051V21.1051Z"
                  fill="#475569"
                />
                {noti.filter((item) => item.seen === false).length !== 0 ? (
                  <>
                    {" "}
                    <circle cx="17" cy="6" r="8" fill="#BE1E2D" />
                    <text
                      x="17"
                      y="7"
                      fill="white"
                      fontSize="8"
                      fontWeight="bold"
                      style={{
                        dominantBaseline: "middle",
                        textAnchor: "middle",
                      }}>
                      {noti.filter((item) => item.seen === false).length}
                    </text>
                  </>
                ) : (
                  ""
                )}
              </svg> */}

              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-[10%] notification-event"
              // onClick={() => push(`/allNotifications`)}
              >
                <circle
                  cx="24"
                  cy="24"
                  r="24"
                  // fill="#F6F5FA"
                  fill={user.theme === "dark" ? "#212b36" : "#F6F5FA"}
                />
                <g clipPath="url(#clip0_807_3068)">
                  <path
                    d="M18.7119 28H29.1492C29.4704 28 29.7869 27.9226 30.0719 27.7745C30.3569 27.6263 30.602 27.4116 30.7865 27.1486C30.971 26.8857 31.0894 26.5822 31.1318 26.2637C31.1742 25.9453 31.1392 25.6214 31.0299 25.3193L29.1285 20.0627C28.8038 18.8945 28.1054 17.8648 27.1401 17.1311C26.1748 16.3974 24.9957 16.0001 23.7832 16C22.521 16 21.2966 16.4304 20.312 17.2202C19.3275 18.01 18.6417 19.1119 18.3679 20.344L16.8012 25.4107C16.709 25.7098 16.6882 26.0264 16.7407 26.335C16.7931 26.6436 16.9172 26.9356 17.1031 27.1875C17.289 27.4394 17.5314 27.6441 17.8108 27.7852C18.0902 27.9264 18.3988 27.9999 18.7119 28Z"
                    fill="#637381"
                  />
                  <path
                    d="M20.7334 29.3335C20.8864 30.087 21.2952 30.7645 21.8906 31.2511C22.4859 31.7377 23.2312 32.0035 24.0001 32.0035C24.769 32.0035 25.5142 31.7377 26.1096 31.2511C26.7049 30.7645 27.1137 30.087 27.2667 29.3335H20.7334Z"
                    fill="#637381"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_807_3068">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(16 16)"
                    />
                  </clipPath>
                </defs>

                {/* Conditional rendering for circle and text */}
                {noti.filter((item) => item.seen === false).length !== 0 && (
                  <>
                    {/* <circle cx="36" cy="12" r="8" fill="#BE1E2D" /> */}
                    <circle cx="32" cy="16" r="8" fill="#BE1E2D" />
                    <text
                      x="32" //36.12
                      y="16"
                      fill="white"
                      fontSize="10"
                      fontWeight="bold"
                      style={{
                        dominantBaseline: "middle",
                        textAnchor: "middle",
                      }}>
                      {noti.filter((item) => item.seen === false).length}
                    </text>
                  </>
                )}
              </svg>

              <div className="py-1 px-2  opacity-0 group-hover:opacity-100 transition-opacity bg-black rounded-full top-10 -left-6 absolute ">
                <h3 className="text-white font-semibold text-xs">
                  Notification
                </h3>
              </div>
            </button>
            <button
              // ref={profileButtonRef}
              className="profile-event flex items-center mx-[0%] lg:mx-[4%]"
              ref={profileDropdownRef}
              onClick={(e) => {
                handleProfileDropdown(e);
                setopenNoti(false);
              }}>
              <ProfilePicture profilePic={user} />
            </button>
          </div>
        </div>
        {/* mobile SearchBar */}
        {searchMobile ? (
          <input
            type="text"
            onChange={(e) => setText(e.target.value)}
            onClick={(e) => {
              setRecentSearchesDisplay(true);
              // setShowResults(user?.skills.length !== 0);
              handleInputClick(e);
            }}
            value={text}
            className="text-grayish search-tab-event p-3 mt-1 md:p-4 md:mt-0 rounded-lg w-[60vw] text-[0.6rem] sm:hidden h-[2vh] mb-2 fixed top-[0rem] right-[15vw] bg-page border-none"
            placeholder="Search Peers and more"
          />
        ) : (
          ""
        )}

        <div
          className={`hidden sm:${toggleProfileDropdown} fixed top-0 left-0 w-[100%] h-[100%] bg-black opacity-50 text-primary -z-100`}
          onClick={handleProfileDropdown}></div>
        {!openNoti ? (
          <div
            ref={profileWrapperRef}
            className={`hidden sm:${toggleProfileDropdown} mt-3 rounded-full justify-between absolute w-44  bg-card left-[76.5%]  xl:right-[4%] lg:right-[4%] md:right-[5%] sm:right-[1%] z-10 dark:text-primary`}>
            <ul className="w-[100%] rounded-lg">
              <div
                className={`absolute top-0 right-1  -mt-2 w-4 h-6 ${isHovered ? "bg-neutral" : "bg-card"} transform rotate-45`}></div>
              <Link
                to="/profile"
                onClick={() => settoggleProfileDropdown("hidden")}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <li className=" flex px-[1%] py-[3%] items-center transition duration-200 bg-feedNeutral hover:bg-neutral">
                  {/* <AccountCircleOutlinedIcon className="text-[#637381]  dark:text-primary mx-[10%]  mt-[2%]" />{" "} */}

                  <span className="mx-[12%]  mt-[2%]">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z"
                        fill="#637381"
                      />
                      <path
                        d="M8 9.33337C4.68781 9.33706 2.00369 12.0212 2 15.3334C2 15.7016 2.29847 16 2.66666 16H13.3333C13.7015 16 14 15.7016 14 15.3334C13.9963 12.0212 11.3122 9.33703 8 9.33337Z"
                        fill="#637381"
                      />
                    </svg>
                  </span>
                  <span className="text-[#637381] mt-[2%]  dark:text-primary">
                    {" "}
                    My Profile
                  </span>
                </li>
              </Link>

              {/* <div className="flex items-center gap-1">
                      <span>
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="mr-2 md:mx-auto"
                        >
                          <g clipPath="url(#clip0_759_5769)">
                            <path
                              d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                              fill={location === "accountInfo" ? "#008080" : "#637381" }
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_759_5769">
                              <rect width="16" height="16" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span>{" "}
                        Account Info</span>
                    </div> */}

              {/* <hr className="border-viewMore" /> */}

              <li
                className="flex px-[1%] py-[3%] bg-feedNeutral hover:bg-neutral items-center cursor-pointer  "
                onClick={handleTheme}>
                {isDark ? (
                  <>
                    <LightModeIcon
                      className="text-[#637381] mx-[10%]  dark:text-primary  mt-[2%]"
                      sx={{ color: "#b3b3b3" }}
                    />
                    <span className="text-[#637381]  mt-[2%]  dark:text-primary">
                      Light
                    </span>
                  </>
                ) : (
                  <>
                    <DarkModeIcon
                      className="text-[#637381] mx-[10%]  mt-[2%]  dark:text-primary"
                      sx={{ color: "#637381" }}
                    />
                    <span className="text-[#637381]  dark:text-primary">
                      Dark
                    </span>
                  </>
                )}
              </li>

              {/* <hr className="border-viewMore" /> */}
              <Link
                to={`/accountInfo/${user._id}`}
                onClick={() => settoggleProfileDropdown("hidden")}>
                <li className="flex px-[1%] py-[3%] items-center  transition duration-200 bg-feedNeutral hover:bg-neutral ">
                  <SettingsOutlinedIcon className="text-[#637381]  mx-[10%]  dark:text-primary mt-[2%]" />{" "}
                  <span className="text-[#637381] mt-[2%]  dark:text-primary">
                    Settings
                  </span>
                </li>
              </Link>

              {/* <hr className="border-viewMore" /> */}
              <Link
                to={`/competition`}
                onClick={() => settoggleProfileDropdown("hidden")}>
                <li className="flex px-[1%] py-[3%] items-center  transition duration-200 bg-feedNeutral hover:bg-neutral ">
                  {/* <EmojiEventsIcon className="text-[#637381]  mx-[10%]  dark:text-primary mt-[2%]" />{" "} */}
                  <span className="mx-[12%]  mt-[2%]">
                    <svg
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.73728 10H8.23699C11.8849 10 13.1792 7.81252 13.1792 5.93752C13.1787 5.42939 13.0227 4.93732 12.7381 4.5458C12.4536 4.15427 12.0581 3.88772 11.6197 3.7919C11.7075 3.58993 11.7826 3.38106 11.8442 3.1669C11.9401 2.80124 11.9589 2.41502 11.8992 2.03954C11.8395 1.66405 11.7029 1.30985 11.5005 1.00565C11.2963 0.692173 11.0301 0.4378 10.7235 0.2631C10.4169 0.0884008 10.0785 -0.00172037 9.73558 2.48729e-05H3.44361C3.1006 -0.00150371 2.76208 0.0889061 2.45547 0.263937C2.14885 0.438968 1.88275 0.693703 1.6787 1.00752C1.47629 1.31173 1.3397 1.66592 1.27997 2.04141C1.22025 2.4169 1.23908 2.80312 1.33494 3.16877C1.39662 3.38294 1.47168 3.5918 1.55954 3.79377C1.12137 3.88953 0.726128 4.15581 0.441583 4.54695C0.157037 4.93809 0.000919058 5.42971 0 5.93752C0 7.81252 1.29431 10 4.9422 10H5.44191C5.4739 10.1898 5.49044 10.3825 5.49133 10.5756V12.5C5.50076 12.667 5.47882 12.8343 5.42697 12.9908C5.37511 13.1473 5.29453 13.2895 5.19061 13.4078C5.08668 13.526 4.96179 13.6178 4.82426 13.6768C4.68674 13.7358 4.53974 13.7608 4.39306 13.75H3.2948C3.14916 13.75 3.00948 13.8159 2.9065 13.9331C2.80352 14.0503 2.74566 14.2093 2.74566 14.375C2.74566 14.5408 2.80352 14.6998 2.9065 14.817C3.00948 14.9342 3.14916 15 3.2948 15H9.88439C10.03 15 10.1697 14.9342 10.2727 14.817C10.3757 14.6998 10.4335 14.5408 10.4335 14.375C10.4335 14.2093 10.3757 14.0503 10.2727 13.9331C10.1697 13.8159 10.03 13.75 9.88439 13.75H8.78942C8.64252 13.7611 8.49524 13.7364 8.3574 13.6776C8.21955 13.6187 8.09432 13.5271 7.99007 13.4088C7.88581 13.2905 7.80493 13.1482 7.75281 12.9915C7.7007 12.8348 7.67856 12.6672 7.68786 12.5V10.575C7.68878 10.382 7.70532 10.1896 7.73728 10ZM8.63566 8.21815C9.57658 7.26944 10.3906 6.16927 11.0518 4.95252C11.117 4.98322 11.1867 4.99934 11.2572 5.00002C11.4757 5.00002 11.6852 5.0988 11.8397 5.27461C11.9941 5.45043 12.0809 5.68888 12.0809 5.93752C12.0809 7.29752 11.0711 8.75002 8.23699 8.75002H8.20624C8.33006 8.55371 8.47424 8.37513 8.63566 8.21815ZM4.9422 8.75002C2.10812 8.75002 1.09827 7.29752 1.09827 5.93752C1.09827 5.68888 1.18505 5.45043 1.33952 5.27461C1.494 5.0988 1.70351 5.00003 1.92197 5.00002C1.99265 4.99942 2.06257 4.9833 2.12789 4.95252C2.78915 6.16927 3.60316 7.26944 4.54408 8.21815C4.7053 8.37517 4.8493 8.55375 4.97295 8.75002H4.9422Z"
                        fill="#637381"
                      />
                    </svg>
                  </span>
                  <span className="text-[#637381] mt-[2%]  dark:text-primary">
                    {" "}
                    Competition
                  </span>
                </li>
              </Link>
              <Link
                to={`/mystatistics/${user._id}`}
                onClick={() => settoggleProfileDropdown("hidden")}>
                <li className=" flex px-[1%] py-[3%] items-center transition duration-200 bg-feedNeutral hover:bg-neutral">
                  {/* <AccountCircleOutlinedIcon className="text-[#637381]  dark:text-primary mx-[10%]  mt-[2%]" />{" "} */}

                  <span className="mx-[10%]  mt-[2%]">
                    <AnalyticsIcon className="text-[#637381]" />
                  </span>
                  <span className="text-[#637381] mt-[2%]  dark:text-primary">
                    {" "}
                    My Statistics
                  </span>
                </li>
              </Link>
              <Link to="#">
                <li
                  className="flex px-[2%] py-[3%] items-center transition   duration-200 bg-feedNeutral hover:bg-neutral rounded-b-lg"
                  onClick={() => setShowLogoutModal(true)}>
                  <LogoutOutlinedIcon className="text-[#637381]  dark:text-primary mx-[10%]  mt-[2%]" />{" "}
                  <span className="text-[#637381]  dark:text-primary mt-[2%]">
                    Logout
                  </span>
                </li>
              </Link>
              {/* <hr className="border-viewMore" /> */}
            </ul>
          </div>
        ) : (
          <div className={`hidden sm:${toggleProfileDropdown}`}>
            {" "}
            <NotificationCard
              settoggleProfileDropdown={settoggleProfileDropdown}
            />
          </div>
        )}
        <div
          className={`hidden sm:${togglePostDropdown} fixed top-0 left-0 w-[100%] h-[100%] bg-black opacity-50 text-primaryopacity-80 -z-10`}
          onClick={handlePostDropdown}></div>
        <div
          ref={postWrapperRef}
          className={`hidden sm:${togglePostDropdown} justify-between mt-3 absolute w-44 text-primary    sm:right-[30%] md:right-[30%] lg:right-[33%] xl:right-[33%] z-10`}>
          <ul className="w-[100%]">
            <div
              className={`absolute top-0 right-4 -mt-2 w-4 h-6 ${isHovered ? "bg-neutral" : "bg-card"} transform rotate-45 `}></div>

            <Link
              to="#"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}>
              <li
                className="flex  py-[3%] items-center bg-feedNeutral hover:bg-neutral"
                onClick={handletogglePostVideoContent}>
                <VideocamIcon className="text-grayish mx-[10%]  mt-[2%]" />{" "}
                <span className="text-grayish mt-[2%]">Post Video</span>
              </li>
            </Link>
            {/* <hr className="border-viewMore" /> */}
            <Link to="#">
              <li
                className="flex  py-[3%] items-center bg-feedNeutral hover:bg-neutral"
                onClick={handletogglePostImageContent}>
                <PhotoCameraIcon className="text-grayish mx-[10%]  mt-[2%]" />{" "}
                <span className="text-grayish mt-[2%]">Post Image</span>
              </li>
            </Link>
            {/* <hr className="border-viewMore" /> */}
            <Link to="#">
              <li
                className="flex  py-[3%] items-center  bg-feedNeutral hover:bg-neutral"
                onClick={handletogglePostContent}>
                <TextSnippetIcon className="text-grayish mx-[10%] mt-[2%]" />{" "}
                <span className="text-grayish mt-[2%]">Post Content</span>
              </li>
            </Link>
          </ul>
        </div>
        <div
          className={`hidden sm:${toggleMsgDropdown} fixed top-0 left-0 w-[100%] h-[100%] bg-card opacity-80 -z-10`}
          onClick={handleMsgDropdown}></div>
        <div
          ref={msgWrapperRef}
          className={`hidden sm:${toggleMsgDropdown} justify-between absolute w-48 bg-card text-primary shadow-lg border-viewMore border sm:right-[8%]  lg:right-[16%] md:right-[16%] xl:right-[19%] z-10  rounded-2xl`}>
          <ul className="w-[100%]">
            {Conversation.slice(0, 3).map((chat, index) => {
              return (
                <div key={chat.chatName + "" + index}>
                  <li className="flex ml-[1%] my-[3%]  items-center w-[100%]">
                    {chat.isGroupChat ? (
                      <GroupsRoundedIcon
                        fontSize="large"
                        className="text-slate-500 mr-[0%]  mt-[2%] w-1/4"
                      />
                    ) : (
                      <AccountCircleIcon
                        fontSize="large"
                        className="text-slate-500 mr-[0%]  mt-[2%] w-1/4"
                      />
                    )}
                    <div className="mt-[2%] w-3/4">
                      <div className="ml-[3%] w-[100%]">
                        <span className="text-primary">
                          {chat.isGroupChat
                            ? chat.chatName
                            : chat.users.filter((c) => c._id !== user._id)[0]
                              .firstName +
                            "  " +
                            chat.users.filter((c) => c._id !== user._id)[0]
                              .lastName}{" "}
                        </span>
                        <div className="flex flex-row justify-between text-sm">
                          <h6 className="text-primary">
                            {chat.latestMessage !== undefined
                              ? to_Decrypt(chat.latestMessage.content).length >
                                12
                                ? to_Decrypt(chat.latestMessage.content).slice(
                                  12
                                ) + "..."
                                : to_Decrypt(chat.latestMessage.content)
                              : "No messages!!!"}
                          </h6>
                          <h6 className="text-slate-500">
                            {chat.latestMessage &&
                              format(chat.latestMessage.createdAt)}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </li>
                </div>
              );
            })}

            <li className="flex py-[3%] justify-center rounded-2xl items-center hover:bg-primary">
              <div className="py-[1%]">
                <Link to="/chatting">
                  <button
                    className="p-2 px-5 w-[100%] "
                    onClick={() => {
                      // setMessageUnseen(false);
                      settoggleMsgDropdown("hidden");
                    }}>
                    {" "}
                    <h2 className="text-blackGray">See all messages</h2>{" "}
                  </button>
                </Link>
              </div>
            </li>
          </ul>
        </div>
        <div
          ref={notificationWrapperRef}
          className={`hidden sm:${toggleNotificationDropdown} justify-between absolute w-64 text-primary rounded-2xl shadow-lg  sm:right-[8%]  lg:right-[16%] md:right-[16%] xl:right-[19%] z-10`}>
          <ul className="mx-1 w-[100%]">
            <li className="flex ml-[1%] my-[3%]  items-center w-[100%]">
              <AccountCircleIcon
                fontSize="large"
                className="text-slate-500 mr-[0%]  mt-[2%] w-1/4"
              />
              <div className="mt-[2%] w-3/4">
                <div className="ml-[3%] w-[100%]">
                  <span className="text-primary">Manish </span>
                  <div className="flex flex-row justify-between text-sm">
                    <h6 className="text-primary">Hi how are you?</h6>
                    <h6 className="text-slate-500">1min ago</h6>
                  </div>
                </div>
              </div>
            </li>
            <hr className="border-viewMore" />
            <li className="flex ml-[1%] my-[3%]  items-center w-[100%]">
              <AccountCircleIcon
                fontSize="large"
                className="text-slate-500 mr-[0%]  mt-[2%] w-1/4"
              />
              <div className="mt-[2%] w-3/4">
                <div className="ml-[3%] w-[100%]">
                  Apurba Das
                  <div className="flex flex-row justify-between text-sm">
                    <h6>Hi how are you?</h6>
                    <h6 className="">1min ago</h6>
                  </div>
                </div>
              </div>
            </li>
            <hr className="border-viewMore" />
            <li className="flex ml-[1%] my-[3%]  items-center w-[100%]">
              <AccountCircleIcon
                fontSize="large"
                className="text-slate-500 mr-[0%]  mt-[2%] w-1/4"
              />
              <div className="mt-[2%] w-3/4">
                <div className="ml-[3%] w-[100%]">
                  Apurba Das
                  <div className="flex flex-row justify-between text-sm">
                    <h6>Hi how are you?</h6>
                    <h6 className="">1min ago</h6>
                  </div>
                </div>
              </div>
            </li>
            <hr className="border-viewMore" />
            <li className="flex  my-[3%] justify-center items-center w-[100%]">
              <div className="my-[1%]">
                <button className="p-2 px-5 rounded-3xl bg-slate-200">
                  {" "}
                  <h2 className="text-blackGray">See all messages</h2>{" "}
                </button>
              </div>
            </li>

            <hr className="border-viewMore" />
          </ul>
        </div>

        <Suspense fallback={<FallbackUI />}>
          {togglePostContent && (
            <div ref={postContentWrapperRef}>
              <UploadBlog toggle={handletogglePostContent} />
            </div>
          )}

          {togglePostImageContent && (
            <div ref={postImageWrapperRef}>
              <UploadImage
                toggle={handletogglePostImageContent}
                redirect={redirectModal}
              />
            </div>
          )}

          {togglePostVideoContent && (
            <div>
              <UploadVideos
                settogglePostVideoContent={settogglePostVideoContent}
                toggle={handletogglePostVideoContent}
                // settogglePostVideoContent={settogglePostVideoContent}
                redirect={redirectModal}
              />
            </div>
          )}
        </Suspense>
        <div
          className={`hidden sm:${searchResultDisplay ? "flex" : ""
            } fixed top-0 left-0 w-[100%] h-[100%] bg-black text-primary opacity-50 blur-3xl  -z-10`}
          onClick={() => setSearchResultDisplay((prev) => !prev)}></div>
      </div>
    </>
  );
}
export default React.memo(Header);